const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'trees'
	],

	config: {
		treeTypeComponents: {
			default: [
				'/',
				'templates',
				'componentTrees',
				'componentTree'
			]
		},
		showComponentsOnly: false,
		isImporter: false
	},

	model: {
		localAtoms: {}, // used to store full local list of existing atoms in case this component is used as componentStructureImporter.
	},

	methods: {
		// operations
		showInsert: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			if(this.actions[baseActionKey]){
				var insertBefore    = buttonMode === 'before';
				var insertWithin    = buttonMode === 'within';
				var insertAfter     = buttonMode === 'after';
				var groupEntry 		= buttonMode === 'group';
				var rootEntry       = buttonMode === 'root' || groupEntry;
				var nodeData        = this.getSelectedNodeData();
				var sort;
				var parentComponentID;
				var newConfig = {};

				if(buttonContext === 'component'){
					if(rootEntry){
						parentComponentID = 0;
					}
					else {
						newConfig.gui_group = (nodeData.config || {}).gui_group || 'ALL';

						if(insertBefore){
							sort                = nodeData.sort;
							parentComponentID   = nodeData.parentComponentID;

						}
						else if(insertAfter){
							sort                = nodeData.sort + 1;
							parentComponentID   = nodeData.parentComponentID;
						}
						else if(insertWithin){
							parentComponentID = nodeData._primaryKey || nodeData.id;
						}
						else {
							// TODO: throw error
							console.error('invalid position found for new entry');
						}
					}

					if(groupEntry && actionBossComponent){
						newConfig.gui_group = (actionBossComponent.getSelectedNodeData() || {}).name || 'ALL';
					}

					return this.performAction(
						this.prepareAction(baseActionKey, undefined, undefined, {
							source: {
								load: {
									componentData: {
										actions: {
											loadContent: {
												source: {
													load: {
														componentData: {
															model: {
																dirtyFields: {
																	data: {
																		attributes: {
																			parentComponentID:  parentComponentID,
																			sort:               sort,
																			config: 			newConfig
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						})
					);
				}
				else if(buttonContext === 'section'){
					if(nodeData && nodeData.templateID){
						return this.performAction(
							this.prepareAction(baseActionKey, undefined, undefined, {
								source: {
									load: {
										componentData: {
											actions: {
												loadContent: {
													source: {
														load: {
															componentData: {
																model: {
																	dirtyFields: {
																		data: {
																			attributes: {
																				templateID:   nodeData.templateID
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							})
						);
					}
				}
				else if(buttonContext === 'atom'){
					return this.performAndStoreAction(baseActionKey);
				}
				else if(buttonContext === 'templateAtom'){
					return this.performAndStoreAction(baseActionKey);
				}
			}

			return utils.promise.reject();
		},

		duplicate: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var self        = this;
			var nodeData    = this.getSelectedNodeData();
			var dirtyData   = {};
			if(nodeData.sort !== undefined){
				dirtyData = {
					data: {
						attributes: {
							sort: nodeData.sort + 1,
						}
					}
				};
			}

			if(this.actions[baseActionKey] && nodeData._primaryKey){

				return this.performAction(
					this.prepareAction(baseActionKey, nodeData._primaryKey, undefined, {
						source: {
							submit: {
								data: dirtyData
							}
						}
					})
				).then(function(context) {
					self.config.readyNodeID = context.response.data.attributes[context.response.data.primaryKey];
					self.config.readyNodeContext = buttonContext;
					self.refreshTrees();

					return utils.promise.resolve(context);
				});

			}

			return utils.promise.reject();
		},

		showDuplicate: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var nodeData    = this.getSelectedNodeData();
			var dirtyData   = {};
			if(nodeData.sort !== undefined){
				dirtyData = {
					data: {
						attributes: {
							sort: nodeData.sort + 1
						}
					}
				};
			}

			if(this.actions[baseActionKey] && nodeData._primaryKey){

				return this.performAction(
					this.prepareAction(baseActionKey, nodeData._primaryKey, undefined, {
						source: {
							load: {
								componentData: {
									actions: {
										loadContent: {
											source: {
												load: {
													componentData: {
														model: {
															dirtyFields: dirtyData
														}
													}
												}
											}
										}
									}
								}
							}
						}
					})
				);
			}

			return utils.promise.reject();
		},

		insert: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, data){
			if(this.actions[baseActionKey]){
				if(buttonContext === 'templateAtom'){
					return this.performAction(
						this.prepareAction(baseActionKey, undefined, undefined, {
							source: {
								submit: {
									data: data
								}
							}
						})
					);
				}
			}

			return utils.promise.reject();
		},

		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var self = this;

			return self.performDecision(
				'confirm',
				{
					component:  self,
					title:      storage.__('hint.delete.really.' + buttonContext + '.title'),
					message:    storage.__('hint.delete.really.' + buttonContext + '.message')
				}
			).then(function(context) {
				if (context.decision.type === 'yes') {
					if(self.actions[baseActionKey]){
						var nodeID          = self.getSelectedNodeID();
						var nodeIndex       = self.getSelectedNodeIndex();
						var performActions  = [];
						self.deselectActiveNode();

						self.setClosestNodeAsReady(nodeIndex);

						performActions.push(self.performAction(
							self.prepareAction(baseActionKey, nodeID)
						));

						return utils.promise.performAll(self, performActions).then(function(context){
							self.refreshTrees();
							return context;
						});
					}
				}

				return utils.promise.reject();
			});
		},

		showExport: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			if(this.actions[baseActionKey]){
				return this.performAndStoreAction(
					`${baseActionKey}_inEffect`,
					this.prepareAction(baseActionKey),
					true
				);
			}

			return utils.promise.reject();
		},

		showImport: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			if(this.actions[baseActionKey]){
				return this.performAndStoreAction(
					`${baseActionKey}_inEffect`,
					this.prepareAction(baseActionKey),
					true
				);
			}

			return utils.promise.reject();
		},

		import: function(importStructure, localAtoms){

			let statusController;
			if((statusController = getComponent('statusController'))){
				statusController.showStatus('status.progress.import');
			}

			// init
			importStructure = importStructure || {}
			importStructure.data = importStructure.data || []
			localAtoms = localAtoms || {}
			const self = this
			let insertAtomsPromise = utils.promise.resolve()
			const stats = {
				nrOfAddedAtoms: 0,
				nrOfAddedComponents: 0,
			}

			// collect importAtoms
			const importAtomsByCode = {}
			utils.forEach(importStructure.data, component => {
				utils.forEach(((((((component || {}).children || {}).cpTpl || {}).data || {}).children || {}).tplAtoms || {}).data || [], templateAtom => {
					const importAtom = (((templateAtom || {}).children || {}).tplAtom || {}).data || {}
					const importAtomAttributes = importAtom.attributes || {}
					if(importAtomAttributes.code){
						if(!importAtomsByCode[importAtomAttributes.code]){
							importAtomsByCode[importAtomAttributes.code] = utils.simpleCopy(importAtom)
						}
					}
				})
			})

			// collect localAtoms
			const localAtomsByCode = {}
			utils.forEach(localAtoms.data || [], localAtom => {
				const localAtomAttributes = localAtom.attributes || {}
				if(localAtomAttributes.code){
					localAtomsByCode[localAtomAttributes.code] = utils.simpleCopy(localAtom)
				}
			})

			// filter importAtoms which do not exist locally
			if(utils.collectionSize(importAtomsByCode) > 0){
				utils.forEach(importAtomsByCode, (importAtom, importAtomCode) => {
					if(localAtomsByCode[importAtomCode]){
						delete importAtomsByCode[importAtomCode]
					}
				})
			}

			// insert new importAtoms if necessary
			if(utils.collectionSize(importAtomsByCode) > 0){
				// remove ids
				utils.forEach(importAtomsByCode, importAtom => {
					const importAtomPrimaryKey = importAtom.primaryKey || 'id'
					delete importAtom.attributes[importAtomPrimaryKey]
					utils.forEach(((importAtom.relationships || {}).cms_atomsTrl || {}).data || [], importAtomTrl => {
						delete importAtomTrl.attributes[importAtomTrl.primaryKey || 'id']
						delete importAtomTrl.attributes[importAtomPrimaryKey]
					})

					// correct trls name
					if(utils.collectionSize((importAtom.relationships || {}).cms_atomsTrl) > 0){
						importAtom.relationships.trls = importAtom.relationships.cms_atomsTrl
						delete importAtom.relationships.cms_atomsTrl
					}
				})

				insertAtomsPromise = this.performAction(
					this.prepareAction(
						'insert_atom',
						undefined,
						undefined,
						{
							statusControllerLoadingMessage: '',
							statusControllerSavingMessage: '',
							source: {
								submit: {
									data: {
										data: Object.values(importAtomsByCode)
									}
								}
							}
						}
					)
				).then(actionContext => {

					// extend localAtom list by newly inserted importAtoms
					const responseData = ((actionContext || {}).response || {}).data || []
					stats.nrOfAddedAtoms = utils.collectionSize(responseData)

					utils.forEach(responseData, newLocalAtom => {
						const newLocalAtomAttributes = newLocalAtom.attributes || {}
						if(newLocalAtomAttributes.code && newLocalAtomAttributes[newLocalAtom.primaryKey || 'id']){
							localAtomsByCode[newLocalAtomAttributes.code] = utils.simpleCopy(newLocalAtom)
						}
					})

					return utils.promise.resolve()
				}).fail(error => {
					console.error('import atoms error', error)
					return utils.promise.reject(error)
				})
			}


			return insertAtomsPromise
				.then(() => {
					// sanitize importStructure (components): get rid of primary and foreign keys, assign local atoms, sanitize trl structures, ...
					const componentByID = {}

					utils.forEach(importStructure.data, component => {
						component = component || {}
						const primaryKey = (component.attributes || {})[component.primaryKey || 'id']
						if(primaryKey){
							componentByID[primaryKey] = component
						}
					});

					utils.forEach(importStructure.data, component => {
						component = component || {}
						const componentAttributes = component.attributes || {}
						component.meta = component.meta || {}
						component.meta.componentID = componentAttributes[component.primaryKey || 'id']

						// sanitize component
						delete componentAttributes[component.primaryKey || 'id']
						delete componentAttributes.templateID
						delete componentAttributes.sort
						if((component.relationships || {}).cms_componentsTrl){
							utils.forEach(component.relationships.cms_componentsTrl.data || [], componentTrl => {
								delete (componentTrl.attributes || {})[componentTrl.primaryKey || 'id']
								delete (componentTrl.attributes || {}).componentID
							})
							component.relationships.trls = component.relationships.cms_componentsTrl
							delete component.relationships.cms_componentsTrl
						}
						if(componentAttributes.parentComponentID){
							if(componentByID[componentAttributes.parentComponentID]){
								component.meta.parentComponentID = componentAttributes.parentComponentID;
								componentAttributes.parentComponentID = 0
							} else {
								// nothing one can do about a parentComponent which has not been imported.
								componentAttributes.parentComponentID = 0
							}
						}

						// sanitize template
						const template = ((component.children || {}).cpTpl || {}).data || {}
						const templateAttributes = template.attributes || {}
						delete templateAttributes[template.primaryKey || 'id']
						if((template.relationships || {}).cms_templatesTrl){
							utils.forEach(template.relationships.cms_templatesTrl.data || [], templateTrl => {
								delete (templateTrl.attributes || {})[templateTrl.primaryKey || 'id']
								delete (templateTrl.attributes || {}).templateID
							})
							template.relationships.trls = template.relationships.cms_templatesTrl
							delete template.relationships.cms_templatesTrl
						}

						// sanitize sections
						if((template.children || {}).tplSct){
							utils.forEach(((template.children || {}).tplSct || {}).data || [], templateSection => {
								templateSection = templateSection || {}
								delete (templateSection.attributes || {})[templateSection.primaryKey || 'id']
								delete (templateSection.attributes || {}).templateID

								if((templateSection.relationships || {}).cms_sectionsTrl){
									utils.forEach(templateSection.relationships.cms_sectionsTrl.data || [], templateSectionTrl => {
										delete (templateSectionTrl.attributes || {})[templateSectionTrl.primaryKey || 'id']
										delete (templateSectionTrl.attributes || {}).sectionID
									})

									templateSection.relationships.trls = templateSection.relationships.cms_sectionsTrl
									delete templateSection.relationships.cms_sectionsTrl
								}
							})
						}

						// sanitize templateAtoms
						utils.forEach(((template.children || {}).tplAtoms || {}).data || [], templateAtom => {
							const templateAtomAttributes = templateAtom.attributes || {}
							const atom = ((templateAtom.children || {}).tplAtom || {}).data || {}
							const atomAttributes = atom.attributes || {}
							const atomCode = atomAttributes.code
							if(atomCode && localAtomsByCode[atomCode]){
								const localAtomPrimaryKey = localAtomsByCode[atomCode].attributes[localAtomsByCode[atomCode].primaryKey || 'id']
								if(localAtomPrimaryKey){
									templateAtomAttributes.atomID = localAtomPrimaryKey

									delete templateAtom.children.tplAtom
									delete templateAtomAttributes[templateAtom.primaryKey || 'id']
									delete templateAtomAttributes.templateID

									if((templateAtom.relationships || {}).cms_templatesAtomsTrl){
										utils.forEach(templateAtom.relationships.cms_templatesAtomsTrl.data || [], templateAtomTrl => {
											delete (templateAtomTrl.attributes || {})[templateAtomTrl.primaryKey || 'id']
											delete (templateAtomTrl.attributes || {}).templateAtomID
										})

										templateAtom.relationships.trls = templateAtom.relationships.cms_templatesAtomsTrl
										delete templateAtom.relationships.cms_templatesAtomsTrl
									}
								}
							}
						})
					})

					return utils.promise.performChain(
						importStructure.data.map(component => (() =>
							self.performAction(
								self.prepareAction(
									'insert_component',
									undefined,
									undefined,
									{
										statusControllerLoadingMessage: '',
										statusControllerSavingMessage: '',
										source: {
											submit: {
												data: {
													data: component
												}
											}
										}
									}
								)
							).fail(error => {
								console.log(error)
							}).then(actionContext => {
								// correct parentComponentIDs if possible
								const component = (actionContext.response || {}).data || {}
								const componentID = (component.attributes || {})[component.primaryKey || 'id']
								const importComponentID = component.meta.componentID || 0
								if(importComponentID && componentID){
									utils.forEach(importStructure.data, newComponent => {
										newComponent = newComponent || {}
										if((newComponent.meta || {}).parentComponentID === importComponentID){
											newComponent.attributes.parentComponentID = componentID
										}
									})
								}

								return utils.promise.resolve()
							})
						))
					)
						.then(() => {
							stats.nrOfAddedComponents = utils.collectionSize(importStructure.data)

							let statusController;
							if((statusController = getComponent('statusController'))){
								statusController.removeStatus()
							}

							self.refreshTrees()

							return self.performAction(
								self.prepareAction('message', undefined, {
									messageDisplay: {
										title: 'components.interface.importDone.title',
										message: 'components.interface.importDone.message',
										variables: stats || {}
									}
								}, {
									statusControllerLoadingMessage: '',
									statusControllerSavingMessage:  ''
								})
							);
						})
						.fail(error => {
							console.error('import components error', error)
							return utils.promise.reject(error)
						})
				})
		},

		sanitizeResources(storage){
			var self = this;
			var resources = {
				initialized: false,
				trees: [
					{
						name: 'Komponenten...',
						tree: [],
						nodes: {}
						// type: 'default'
					}
				]
			};
			var tree = resources.trees[0].tree;
			var nodes = resources.trees[0].nodes;
			var componentIndex, groupIndex;
			var contextIcon;

			if(this.resourceData.data && !this.resourceData.initialized) {
				this.resetNodeMappings();
				this.config.extendedTreeView = this.hasRoleOption('extendedTreeView');
				resources.initialized = true;

				// check parentComponentID if necessary
				var parentComponentID, freeChildUsageAllowed = false;
				if(this.config.checkParentComponentID){
					var componentTrees = this.getResourceRegisterContent('componentTrees');
					if(componentTrees){
						if(componentTrees.parentComponentID) 		parentComponentID 		= componentTrees.parentComponentID;
						if(componentTrees.freeChildUsageAllowed) 	freeChildUsageAllowed 	= componentTrees.freeChildUsageAllowed;
					}
				}

				var skipComponent = false;
				var addComponentGroups = {};
				var componentGroup;

				// save importer additional data
				if(this.config.isImporter){
					if(utils.collectionSize(this.resourceData.atoms) > 0){
						this.model.localAtoms = utils.simpleCopy(this.resourceData.atoms)
					}

					return
				}

				utils.forEach(this.resourceData.data, function (componentData) {
					if( componentData.children.cpTpl.data.attributes) {
						var primaryKey = componentData.attributes[componentData.primaryKey];
						var template = componentData.children.cpTpl.data.attributes;
						contextIcon = undefined;

						// check if this component should be skipped from selection
						skipComponent = false;
						if(self.config.checkParentComponentID && !freeChildUsageAllowed){
							var recursiveUsageAllowed = componentData.attributes.config && !!componentData.attributes.config.recursiveUsageAllowed;
							var freeUsageAllowed = componentData.attributes.config && !!componentData.attributes.config.freeUsageAllowed;
							if(
								// do not skip free usage components?
								!freeUsageAllowed
								&&
								// root entry violation
								(parentComponentID || !utils.isEmpty(componentData.attributes.parentComponentID))
								&&
								// parent entry violation
								(!parentComponentID || (!componentData.attributes.parentComponentID || componentData.attributes.parentComponentID != parentComponentID) && (!recursiveUsageAllowed || componentData.attributes.componentID != parentComponentID))
							){
								skipComponent = true;
							}
						}

						if(!skipComponent){
							var parent = '#';
							componentGroup = (componentData.attributes.config || {}).gui_group || 'ALL';
							if(!!componentData.attributes.parentComponentID) parent = self.getNodeIndex(componentData.attributes.parentComponentID, 'component');
							if(self.config.checkParentComponentID && !parent) parent = '#';
							componentIndex = self.transformIDToIndex(primaryKey, 'component', 0, tree.length);

							// estimate right text for this leaf
							var text = template.tplSrcFile;
							if(storage.user && componentData.relationships && componentData.relationships.cms_componentsTrl && Array.isArray(componentData.relationships.cms_componentsTrl.data)){
								utils.forEach(componentData.relationships.cms_componentsTrl.data, function(translation){
									if(translation.attributes.langCode == storage.langCode && !utils.isEmpty(translation.attributes.name)){
										text = translation.attributes.name;
										return false;
									}
								});
							}

							if(self.config.extendedTreeView) text += ` [#${primaryKey} - ${componentData.attributes.sort}]`;

							if(componentData.attributes.type === 'form'){
								contextIcon = 'fi fi-form';
							}

							// the config of a component can force an special icon for a component by setting "forceContextIcon" with value of fi-icon (e.g. "fi fi-component")
							if((componentData.attributes.config || {}).forceContextIcon || false){
								contextIcon = componentData.attributes.config.forceContextIcon;
							}

							if(addComponentGroups[componentGroup]) {
								groupIndex = self.getNodeIndex(componentGroup, 'group');
								nodes[groupIndex].minSort = Math.min(nodes[groupIndex].minSort, componentData.attributes.sort);
								nodes[groupIndex].maxSort = Math.max(nodes[groupIndex].maxSort, componentData.attributes.sort);
							} else {
								groupIndex = self.transformIDToIndex(componentGroup, 'group', 0, tree.length);
								addComponentGroups[componentGroup] = {
									id: groupIndex,
									parent: '#',
									text: componentGroup,
									type: 'group',
									icon: 'fi fi-folder',
									state: {
										opened: true,
										disabled: false,
										selected: false
									},
									li_attr: {},
									a_attr: {}
								};
								nodes[groupIndex] = {
									// _primaryKey: 	componentGroup,
									name: 			componentGroup,
									index: 			groupIndex,
									minSort:		componentData.attributes.sort,
									maxSort:		componentData.attributes.sort,
									isGroup: 		true
								};
							}

							tree.push({
								id: componentIndex,
								parent: !parent || parent === '#' ? groupIndex : parent,
								text: text,
								type: 'component',
								icon: contextIcon,
								state: {
									opened: false,
									disabled: false,
									selected: false
								},
								li_attr: {},
								a_attr: {},
								resource: utils.simpleCopy(componentData)
							});
							nodes[componentIndex] = componentData.attributes;
							nodes[componentIndex]._primaryKey = primaryKey;

							if(!self.config.showComponentsOnly && componentData.children.cpTpl.data.children){
								// add template atoms
								if(componentData.children.cpTpl.data.children.tplAtoms && componentData.children.cpTpl.data.children.tplAtoms.data){
									utils.forEach(componentData.children.cpTpl.data.children.tplAtoms.data, function (atomsData) {
										var atomPrimaryKey = atomsData.attributes[atomsData.primaryKey];
										var templateAtomIndex = self.transformIDToIndex(atomPrimaryKey, 'templateAtom', 0, tree.length);
										var text = '[' + atomsData.attributes.fieldCode + ']';

										if(storage.user && atomsData.relationships && atomsData.relationships.cms_templatesAtomsTrl && Array.isArray(atomsData.relationships.cms_templatesAtomsTrl.data)){
											utils.forEach(atomsData.relationships.cms_templatesAtomsTrl.data, function(translation){
												if(translation.attributes.langCode == storage.langCode && !utils.isEmpty(translation.attributes.label)){
													text = translation.attributes.label + ' ' + text;
													return false;
												}
											});
										}

										if(atomsData.children && atomsData.children.tplAtom && atomsData.children.tplAtom.data && atomsData.children.tplAtom.data.attributes && atomsData.children.tplAtom.data.attributes.code){
											text += ' (' + atomsData.children.tplAtom.data.attributes.code + ')';
										}

										if(self.config.extendedTreeView) text += ' [' + atomPrimaryKey + ']';

										tree.push({
											id: templateAtomIndex,
											parent: componentIndex,
											text: text,
											type: 'templateAtom',
											state: {
												opened: false,
												disabled: false,
												selected: false
											},
											li_attr: {},
											a_attr: {}
										});
										nodes[templateAtomIndex] = atomsData.attributes;
										nodes[templateAtomIndex]._primaryKey = atomPrimaryKey;
									});
								}

								// add template sections
								if(componentData.children.cpTpl.data.children.tplSct && componentData.children.cpTpl.data.children.tplSct.data){
									utils.forEach(componentData.children.cpTpl.data.children.tplSct.data, function (sectionsData) {
										var sectionPrimaryKey = sectionsData.attributes[sectionsData.primaryKey];
										var sectionIndex = self.transformIDToIndex(sectionPrimaryKey, 'section', 0, tree.length);
										var text = '[' + sectionsData.attributes.code + ']';

										if(storage.user && sectionsData.relationships && sectionsData.relationships.cms_sectionsTrl && Array.isArray(sectionsData.relationships.cms_sectionsTrl.data)){
											utils.forEach(sectionsData.relationships.cms_sectionsTrl.data, function(translation){
												if(translation.attributes.langCode == storage.langCode && !utils.isEmpty(translation.attributes.name)){
													text = translation.attributes.name + ' ' + text;
													return false;
												}
											});
										}

										if(self.config.extendedTreeView) text += ' [' + sectionPrimaryKey + ']';

										tree.push({
											id: sectionIndex,
											parent: componentIndex,
											text: text,
											type: 'section',
											state: {
												opened: true,
												disabled: false,
												selected: false
											},
											li_attr: {},
											a_attr: {}
										});
										nodes[sectionIndex] = sectionsData.attributes;
										nodes[sectionIndex]._primaryKey = sectionPrimaryKey;
									});
								}
							}
						}
					}
				});

				if(utils.collectionSize(addComponentGroups) > 0){
					utils.forEach(Object.keys(addComponentGroups).sort(), function(groupKey){
						tree.push(addComponentGroups[groupKey]);
					});
				}
				if(utils.collectionSize(addComponentGroups) < 2){
					self.config.maxOpenedLevelOnInit = 2;
				} else {
					self.config.maxOpenedLevelOnInit = 1;
				}

				if(appConfig.isClient && self.config.checkParentComponentID && utils.isEmpty(nodes)){
					this.performAction(
						this.prepareAction(
							'message',
							undefined,
							{
								messageDisplay: {
									message: 'Nach Anwendung der Filter kann keine Komponente mehr gewählt werden...'
								}
							}
						)
					).then(function(context){
						if(self.config.checkParentComponentID){
							self.triggerClosest('onDecision', {
								decisionComponent: self,
								decisionType: 'cancel'
							});
						}
					})
				}

				this.resourceData = resources;
			}
		},

		/**
		 * support multiple action forms.
		 *
		 * @param data      {} - onTreeAction trigger context
		 */
		onTreeAction: function (data) {
			var self = this;
			var actionFormsSelector = '.base_treesManagement_actionsForm';

			switch (data.onTreeActionOptions.eventType) {
				case 'move_node.jstree':
					var moveEntry = data.onTreeActionOptions.eventData.node;
					var moveEntryContext = this.getNodeContext(moveEntry.id);
					var actionKey = data.onTreeActionOptions.operation  + '_' + moveEntryContext;
					if(this.actions[actionKey]){
						var moveNode = this.getNodeData(moveEntry.id);
						var newInParentPosition = data.onTreeActionOptions.eventData.position;
						var newParentEntry, newParentNode;
						var movementAttributes;
						var sortParent, parentSort;
						if(moveEntry.parent && moveEntry.parent !== '#'){
							newParentEntry = this.getNode(moveEntry.parent);
							newParentNode = this.getNodeData(moveEntry.parent);
						}
						sortParent = moveEntry.parent;

						if(moveEntryContext === 'component'){
							movementAttributes = {
								parentComponentID:  0,
								sort:               undefined
							};

							if(newParentEntry && newParentEntry.type === 'group'){
								movementAttributes.config = moveNode.config || {};
								movementAttributes.config.gui_group = newParentNode.name || 'ALL';
								parentSort = newParentNode.minSort;
							}
							// estimate right parent componentID
							else if(newParentNode) {
								movementAttributes.parentComponentID = newParentNode._primaryKey;
								parentSort = newParentNode.sort;
							}

							// estimate right sort
							movementAttributes.sort = this.getNewSortFieldValue(
								moveEntryContext,
								sortParent,
								newInParentPosition,
								parentSort,
								function(nodeEntry, nodeData){
									// is this a component entry?
									return nodeEntry.id != moveEntry.id && (nodeData || {}).componentID != undefined;
								},
								data.onTreeActionOptions.treeComponentIndex
							);

						}
						else if(moveEntryContext === 'templateAtom' || moveEntryContext === 'section'){
							var primaryKey;
							if(moveEntryContext === 'templateAtom') primaryKey = 'templateAtomID';
							else if(moveEntryContext === 'section') primaryKey = 'sectionID';

							if(!newParentNode || newParentNode.componentID === undefined){
								self.refreshTrees();
								throw new Error('template atoms and sections can only be moved into components');
							}

							movementAttributes = {
								templateID:  0,
								sort:        undefined
							};

							// estimate right templateID
							if(newParentNode) movementAttributes.templateID = newParentNode.templateID;
							// estimate right sort
							movementAttributes.sort = this.getNewSortFieldValue(
								moveEntryContext,
								moveEntry.parent,
								newInParentPosition,
								newParentNode.sort,
								function(nodeEntry, nodeData){
									// is this a component entry?
									return nodeEntry.id != moveEntry.id && nodeData[primaryKey] !== undefined;
								},
								data.onTreeActionOptions.treeComponentIndex
							);
						}

						if(movementAttributes){
							this.performAction(
								this.prepareAction(actionKey, moveNode._primaryKey, undefined, {
									source: {
										submit: {
											data: {
												data: {
													attributes: movementAttributes
												}
											}
										}
									}
								})
							).then(function(){
								// refresh to get the lists up to date after movement
								self.refreshTrees();
							}).fail(function(error){
								// prevent wrong gui state from being displayed
								self.refreshTrees();
							});
						}
						else {
							self.refreshTrees();
							throw new Error('NO MOVEMENT ATTRIBUTES FOUND: ' + actionKey + ', ' + moveEntryContext);
						}
					}
					else {
						self.refreshTrees();
						throw new Error('ACTION NOT FOUND: ' + actionKey);
					}

					break;

				case 'select_node.jstree':
					// TODO: impl. animation and animation-delay
					// show page actions if necessary
					this.$.find(actionFormsSelector).hide();
					var selector = '.componentTreesActions';
					if(data.onTreeActionOptions.eventData.node.type === 'templateAtom')  	selector = '.componentTreesTemplateAtomActions';
					else if(data.onTreeActionOptions.eventData.node.type === 'section')  	selector = '.componentTreesSectionActions';
					else if(data.onTreeActionOptions.eventData.node.type === 'group')  		selector = '.componentTreesGroupActions';
					this.$.find(selector).show();

					if(data.onTreeActionOptions.eventData.node.type === 'group'){
						this.$.find('section.properties > *').hide();
					}
					break;

				case 'deselect_node.jstree':
					// hide page actions if necessary
					this.$.find(actionFormsSelector).hide();
					break;
			}
		},

		openJSONEditor: function(dataJSON){
			this.find('base_treesManagement_interfaceHelpersForm', function(formComponent){
				const $jsonEditorButton = formComponent.$.find('.base_form_fields_json-editor-button')
				if($jsonEditorButton.length > 0){
					const jsonEditorButtonComponent = getComponent($jsonEditorButton)
					if(jsonEditorButtonComponent){
						jsonEditorButtonComponent.open(dataJSON)
					}
				}
			})
		}
	},

	hooks: {
		_attach: function($element, options){
			if(!options.refresh && this.config.isImporter){
				this.openJSONEditor('')
			}
		},

		import: function($element, options){
			options = options || {}
			this.import(options.import || {}, options.localAtoms || {})
		},

		async onDecision($element, options){
			var self = this;
			switch(options.decisionType){
				case 'submit':
					switch(options.decisionComponent.componentClass) {
						case 'templates_atomTrees_selectAtomTrees':
							// get selected atom id
							this.model.selectedAtomID = options.data._primaryKey || options.data.id;

							// deselect selected atom for next usage
							options.decisionComponent.deselectActiveNode();

							// show modal with new template atom properties form
							this.showInsert('showInsert_templateAtom', 'templateAtom', undefined, this).then(function(context){
								context.component.actions.showInsert_atom.source.load.component.hide();
							});
							break;

						case 'base_modal_modal':
						case 'templates_modal_modal':
							var modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component;
							if(modalContentComponent){
								if(
									modalContentComponent.hasClass('templates_propertiesForms_componentPropertiesForm')
									||
									modalContentComponent.hasClass('templates_propertiesForms_sectionPropertiesForm')
								){
									await modalContentComponent.submit()
									await options.decisionComponent.hide();
								}
								else if(modalContentComponent.hasClass('templates_propertiesForms_templateAtomPropertiesForm') && this.model.selectedAtomID !== undefined){
									var componentData = this.getSelectedNodeData();
									const context = await this.insert('insert_templateAtom', 'templateAtom', undefined, this, utils.merge(modalContentComponent.model.dirtyFields, {
										data: {
											attributes: {
												atomID:     this.model.selectedAtomID,
												templateID: componentData.templateID
											}
										}
									}))

									// reset form and hide forms' modal
									var templatePropertiesModal         = context.component.actions.showInsert_templateAtom.source.load.component;
									var templatePropertiesFormComponent = templatePropertiesModal.actions.loadContent.source.load.component;
									templatePropertiesFormComponent.model.dirtyFields = {};
									templatePropertiesFormComponent.forEachSubForm(function(subForm){ subForm.model.dirtyFields = {}; });
									await templatePropertiesModal.hide();

									// refresh trees
									self.refreshTrees();
								}
								else if((options.decisionOptions || {}).mode === 'export' && modalContentComponent.hasClass('templates_componentTrees_componentTreesInterface')){
									const checkedNodes = modalContentComponent.getCheckedNodes(true)
									const listOfComponents = checkedNodes.map(element => ((element || {}).original || {}).resource || false).filter(element => !!element)
									self.openJSONEditor({
										data: listOfComponents
									})
								}
							}
							break;
					}
					break;

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							await options.decisionComponent.hide();
							break;
					}
					break;

				default:
				// TODO: ERROR;
			}
		}
	},

	handlers: [
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_componentPropertiesForm',
			handle: function(callerComponent){
				this.deselectActiveNode();
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_componentPropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(insertPerformed){
					this.config.readyNodeID = nodeData.data.attributes[nodeData.data.primaryKey];
					this.config.readyNodeContext = 'component';
					callerComponent.destroy();
				}
				this.refreshTrees();
			}
		},
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_templateAtomPropertiesForm',
			handle: function(callerComponent){
				this.deselectActiveNode();
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_templateAtomPropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(insertPerformed){
					this.config.readyNodeID       = nodeData.data.attributes[nodeData.data.primaryKey];
					this.config.readyNodeContext  = 'templateAtom';
					callerComponent.destroy();
				}
				this.refreshTrees();
			}
		},
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_sectionPropertiesForm',
			handle: function(callerComponent){
				this.deselectActiveNode();
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_sectionPropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(insertPerformed){
					this.config.readyNodeID       = nodeData.data.attributes[nodeData.data.primaryKey];
					this.config.readyNodeContext  = 'section';
					callerComponent.destroy();
				}
				this.refreshTrees();
			}
		}
	]
};
